/**
 *  Checks whether the object has any properties 
 * @param object The object to check.
 * */
export function hasProps<T>(object: T): boolean {
    for(let prop in object || {})
        return true
    return false
}

/**
 * Mimics a logical XOR operator.
 * @param left The left hand side of the XOR operation.
 * @param right The right hand side of the XOR operation.
 */
export function XOR(left: boolean, right: boolean) {
    return (left || right) && !(left && right)
}